import { render, staticRenderFns } from "./DataTableCollapse.vue?vue&type=template&id=561dafe2&scoped=true"
import script from "./DataTableCollapse.vue?vue&type=script&lang=js"
export * from "./DataTableCollapse.vue?vue&type=script&lang=js"
import style0 from "./DataTableCollapse.vue?vue&type=style&index=0&id=561dafe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561dafe2",
  null
  
)

export default component.exports